export default __webpack_public_path__ + "static/media/plain-sticker-l.43bc497e.png";